package link.erpango.quip.catalog

import link.erpango.quip.utils.isDebugBuild

/** Only true in debug builds. Controlled automatically via isDebugBuild. */
val isCatalogEnabled: Boolean get() = isDebugBuild
